import React from 'react';
import MuiTextField, {TextFieldProps} from '@new-components/atoms/MuiTextField';
import {CountrySelectInput, CountrySelectProps} from './CountrySelectInput';

type FormMobileInputProps = Pick<
  TextFieldProps,
  'id' | 'label' | 'helperText' | 'error' | 'name' | 'disabled' | 'defaultValue'
> & {
  countrySelectProps: CountrySelectProps;
  hide?: boolean;
};

export function FormMobileInput({
  countrySelectProps,
  hide,
  helperText,
  ...props
}: FormMobileInputProps) {
  if (hide) return <></>;
  return (
    <MuiTextField
      {...props}
      helperText={!helperText ? ' ' : helperText}
      variant='outlined'
      fullWidth
      sx={{
        ['& .MuiOutlinedInput-root']: {
          fieldset: {
            borderColor: '#BABAC8',
            borderRadius: '12px',
            boxShadow: '0px 1px 2px 0px #1018280D',
            top: 0,
            legend: {
              display: 'none',
            },
          },
        },
      }}
      InputLabelProps={{
        shrink: true,
        sx: {
          fontSize: '15px',
          fontWeight: 500,
          lineHeight: '18.75px',
          letterSpacing: '-0.4000000059604645px',
          textAlign: 'left',
          textUnderlinePosition: 'fromF-font',
          textDecorationSkipInk: 'none',
          color: '#82807E',
          transform: 'none',
          position: 'static',
          marginBottom: '6px',
          '&.Mui-error': {
            color: 'initial',
          },
        },
      }}
      InputProps={{
        startAdornment: <CountrySelectInput {...countrySelectProps} />,
      }}
      inputProps={{
        sx: {
          borderRadius: '12px',
          padding: '8px 12px',
        },
      }}
    />
  );
}
